module.exports = __webpack_public_path__ + "static/img/sex2.b89e849.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/member/sex2.png
// module id = L9+5
// module chunks = 0